
import { ReactNode } from 'react';
import { useAuth } from '../../hooks/useAuth';
import LoginModal from './LoginModal';

interface ProtectedRouteProps {
  children: ReactNode;
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (!user) {
    return <LoginModal isOpen={true} onClose={() => {}} />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
